<div *ngFor="let modal of modals(); trackBy: trackModal" class="confirmation-modal-container">
  <!-- Backdrop -->
  <div
    class="confirmation-modal-backdrop"
    [class.confirmation-modal-backdrop--out]="isAnimatingOut(modal.id)"
    (click)="onBackdropClick($event, modal)"
    [attr.aria-hidden]="true"
  ></div>

  <!-- Modal Dialog -->
  <div
    class="confirmation-modal-wrapper"
    role="dialog"
    aria-modal="true"
    [attr.aria-labelledby]="'confirmation-modal-title-' + modal.id"
    [attr.aria-describedby]="modal.message ? 'confirmation-modal-desc-' + modal.id : null"
    [class.confirmation-modal-wrapper--out]="isAnimatingOut(modal.id)"
  >
    <div class="confirmation-modal-dialog" [ngClass]="getWidthClass(modal.width)">
      <!-- Close Button -->
      <button
        *ngIf="modal.showCloseButton !== false"
        type="button"
        class="confirmation-modal-close"
        (click)="closeModal(modal)"
        (keydown.enter)="closeModal(modal)"
        (keydown.space)="closeModal(modal)"
        aria-label="Fechar modal"
        title="Fechar"
      >
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            fill="currentColor"
          />
        </svg>
      </button>

      <!-- Modal Content -->
      <div class="confirmation-modal-content">
        <!-- Icon -->
        <div *ngIf="modal.icon && modal.icon !== 'none'" class="confirmation-modal-icon-wrapper">
          <div [innerHTML]="getIconSvg(modal.icon)"></div>
        </div>

        <!-- Title -->
        <h2
          *ngIf="modal.title"
          class="confirmation-modal-title"
          [id]="'confirmation-modal-title-' + modal.id"
        >
          {{ modal.title }}
        </h2>

        <!-- Message -->
        <p
          *ngIf="modal.message"
          class="confirmation-modal-message"
          [id]="'confirmation-modal-desc-' + modal.id"
        >
          {{ modal.message }}
        </p>

        <!-- Custom Component (futuro) -->
        <div *ngIf="modal.customComponent" class="confirmation-modal-custom">
          <!-- Aqui você pode adicionar suporte a componentes dinâmicos -->
        </div>
      </div>

      <!-- Modal Actions -->
      <div *ngIf="modal.buttons && modal.buttons.length > 0" class="confirmation-modal-actions">
        <button
          *ngFor="let button of modal.buttons; trackBy: trackButton"
          type="button"
          [ngClass]="getButtonClass(button.variant)"
          [disabled]="button.loading"
          (click)="onButtonClick(modal, button)"
          (keydown.enter)="onButtonClick(modal, button)"
          (keydown.space)="$event.preventDefault(); onButtonClick(modal, button)"
          class="confirmation-modal-button"
        >
          <svg
            *ngIf="button.loading"
            class="confirmation-modal-button-spinner"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              class="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="4"
            ></circle>
            <path
              class="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
          {{ button.label }}
        </button>
      </div>
    </div>
  </div>
</div>
